import { render } from "./systemVolumeSettings.vue?vue&type=template&id=9d82e07c&scoped=true"
import script from "./systemVolumeSettings.vue?vue&type=script&lang=js"
export * from "./systemVolumeSettings.vue?vue&type=script&lang=js"

import "./systemVolumeSettings.vue?vue&type=style&index=0&id=9d82e07c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9d82e07c"

export default script